import axios from 'axios'

const DashboardService = {
  async getStatistics (params = {}) {
    return axios.get('rm/dashboard', { params })
  }
}

export default DashboardService
